import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { phrasesSelectorManualMinusPhraseAddMetrica } from '../../actions/phrases-selector';
import {
    phrasesSelectorAddMinusPhrases,
    phrasesSelectorChangeMinusPhrase,
    phrasesSelectorClearMinusPhrases,
    phrasesSelectorRemoveMinusPhrase
} from '../../actions/phrases-selector/persistentData';
import {
    PhrasesSelectorMinusPhrases,
    PhrasesSelectorMinusPhrasesProps
} from '../../components/PhrasesSelector/PhrasesSelectorMinusPhrases/PhrasesSelectorMinusPhrases';
import { selectPhrasesSelectorData } from '../../selectors/phrasesSelector/phrasesSelector';
import { GroupId } from '../../typings/groups';
import { PhrasesSelectorWizardId } from '../../typings/phrases';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export interface OwnProps {
    wizardId: PhrasesSelectorWizardId;
    groupId: GroupId;
}

type StateProps = TStateProps<PhrasesSelectorMinusPhrasesProps, OwnProps>;
type DispatchProps = TDispatchProps<PhrasesSelectorMinusPhrasesProps, OwnProps>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { wizardId } = ownProps;
    const [, { minusPhrases }] = selectPhrasesSelectorData(state, wizardId);

    return {
        minusPhrases
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    const { wizardId, groupId } = ownProps;

    return {
        onRemove(index: number) {
            dispatch(phrasesSelectorRemoveMinusPhrase(groupId, wizardId, index));
        },
        onChange(index: number, phrase: string) {
            dispatch(phrasesSelectorChangeMinusPhrase(groupId, wizardId, index, phrase));
        },
        onAdd(phrase: string) {
            dispatch(phrasesSelectorAddMinusPhrases(groupId, wizardId, [phrase]));
            dispatch(phrasesSelectorManualMinusPhraseAddMetrica(wizardId));
        },
        onMinusPhrasesClear() {
            dispatch(phrasesSelectorClearMinusPhrases(groupId, wizardId));
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): PhrasesSelectorMinusPhrasesProps => {
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps
    };
};

export const PhrasesSelectorMinusPhrasesContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    PhrasesSelectorMinusPhrasesProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PhrasesSelectorMinusPhrases);
